export default __webpack_public_path__ + "static/isometric-cbd78c0e00a4beba28d4ae3ed8a10122.png";